const Instructions = () => {
  return (
    <div className="bg-white">
      <h1 className="text-2xl font-semibold text-gray-900 mb-4 pb-4 border-b">Instructions</h1>

      <div className="bg-gray-50 rounded-lg p-4">
        <h2 className="text-lg font-bold mb-4">Getting Started</h2>

        <p className="text-gray-700 text-sm mb-6">
          Welcome to <strong>Systems Thinking in Energy: Navigating Costs, Emissions, and Impact</strong>! This course uses an <strong>open educational version</strong> of Sesame Sustainability&apos;s supply chain analysis platform. Please note that this version has limited capabilities compared to the full commercial platform—it is designed specifically for learning and exploration. If you&apos;re interested in licensing the full platform for your organization, please visit{' '}
          <a href="http://sesamesustainability.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 underline">
            sesamesustainability.com
          </a>{' '}
          or contact us at{' '}
          <a href="mailto:info@sesamesustainability.com" className="text-blue-600 hover:text-blue-700 underline">
            info@sesamesustainability.com
          </a>.
        </p>

        <h3 className="text-base font-bold mb-4 mt-6">How to Use This Tool</h3>

        <div className="space-y-4 mb-6 text-sm">
          <div>
            <p className="text-gray-700 font-semibold mb-2 text-sm">Select a pathway template to get started</p>
            <p className="text-gray-700">
              Choose from the <strong>pre-configured pathway templates</strong> designed for common industrial decarbonization scenarios. Each template contains optimized parameters and technology configurations based on real-world applications. These pathways provide a starting point for your analysis and help you understand different approaches to supply chain decarbonization.
            </p>
          </div>

          <div>
            <p className="text-gray-700 font-semibold mb-2 text-sm">Configure your analysis parameters</p>
            <p className="text-gray-700">
              Once you&apos;ve selected a template, a pathway will be created and will appear under <strong>&quot;My Configurations&quot;</strong>. You can customize various parameters within the pathway to explore different scenarios—such as adjusting costs, timelines, or regional factors. You can learn more about{' '}
              <a href="https://docs.sesame.software/user-guides/pathways/modules/#parameters" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 underline">
                configuring pathway parameters
              </a>{' '}
              in the documentation. Note that in this educational version, you <strong>cannot add or remove technologies</strong> from the pathways; you can only modify the parameters of the existing technologies included in your selected template.
            </p>
          </div>

          <div>
            <p className="text-gray-700 font-semibold mb-2 text-sm">Run analysis and view results</p>
            <p className="text-gray-700">
              Execute your configured analysis to see the environmental and economic impacts of different decarbonization strategies. The results will help you understand trade-offs and opportunities within industrial supply chains.
            </p>
          </div>

          <div>
            <p className="text-gray-700 font-semibold mb-2 text-sm">Compare multiple pathways</p>
            <p className="text-gray-700">
              Create multiple pathway variations and compare them side-by-side to evaluate different scenarios. Learn how to{' '}
              <a href="https://docs.sesame.software/user-guides/pathways/comparing-pathways.html#create-a-new-comparison" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 underline">
                generate comparisons
              </a>{' '}
              in the documentation.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Instructions;

